import { useState } from "react";
import { getItemFromLocalStorage } from "../../../Library/helpers";
import "./style.css";
import { FormControl, FormErrorMessage, FormLabel, Input } from "@chakra-ui/react";

const DatePickerInput = ({ DatepickerClassName, label, labelClassName, inputName, className, onChange, errMessage, inputCover, defaultValue, value, isRequired, maxDate }) => {

  const [ theme ] = useState(getItemFromLocalStorage("theme"));

  const onClickHandler = (e) => {
    e.target.showPicker();
  }

  return (
    <FormControl className={`datepicker-field-form-control ${DatepickerClassName}`} isInvalid={errMessage} isRequired={isRequired}>
      {label && <FormLabel className={`datepicker-field-label ${labelClassName}`} >{label}</FormLabel>}
      <div className={`datepicker-custom-cover ${inputCover}`}>
        <Input
          type="date"
          name={inputName}
          className={`${className} ${theme ? "" : "icon-dark"}`}
          defaultValue={defaultValue}
          errorBorderColor="#FF4242"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onClick={onClickHandler}
          max={maxDate}
        />
        <FormErrorMessage className="form-error-message">{errMessage}</FormErrorMessage>
      </div>
    </FormControl>
  )
}

export default DatePickerInput;